import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import React from "react";
import {Link } from "gatsby"

const NavDrawerListItem = ({ icon: Icon, text, url, color }) => {
	return (
		<div>
			<ListItem button key={text} component={Link} to={url}>
				{Icon && (
					<ListItemIcon>
						{" "}
						<Icon title={text} color={color} />
					</ListItemIcon>
				)}
				<ListItemText primary={text} />
			</ListItem>
		</div>
	);
};

export default NavDrawerListItem;
